import { useMemo } from "react";
import { encodeCode128 } from "@iltocat/shared";

const QUIET = 10;

/** A Code 128 barcode as one SVG path, in the label tokens' black on white. */
export function Barcode({ text, label }: { text: string; label: string }) {
  const drawn = useMemo(() => {
    const result = encodeCode128(text);
    if (!result.ok) return { reason: result.reason };
    let path = "";
    let start = -1;
    result.modules.forEach((dark, i) => {
      if (dark && start === -1) start = i;
      if (start !== -1 && (!dark || i === result.modules.length - 1)) {
        path += `M${start + QUIET} 0h${(dark ? i + 1 : i) - start}v1h-${(dark ? i + 1 : i) - start}z`;
        start = -1;
      }
    });
    return { path, width: result.modules.length + QUIET * 2 };
  }, [text]);

  if ("reason" in drawn) return <span className="muted small">{drawn.reason}</span>;

  return (
    <svg
      className="barcode"
      viewBox={`0 0 ${drawn.width} 1`}
      preserveAspectRatio="none"
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
    >
      <rect className="qr-paper" width={drawn.width} height="1" />
      <path className="qr-ink" d={drawn.path} />
    </svg>
  );
}
